import {Component, Input} from '@angular/core';
import {Router} from "@angular/router";
import {Machine} from "../../../model/machine";
import {MachinesService} from "../../../services/machines.service";
import {AuthGuard} from "../../../common/auth-guard.service";
import {AlarmType} from "../../../model/alarm-type";
import {AlarmTelemetryData} from "../../../model/alarm-telemetry-data";

@Component({
  selector: 'app-map-machine-details',
  templateUrl: './map-machine-details.component.html',
  styleUrls: ['./map-machine-details.component.scss']
})
export class MapMachineDetailsComponent {

  public machine: Machine;
  public lastAlarmDate: string;
  public lastEventDate: string;

  private machinesMap: Map<string, Machine>;


  constructor(private router: Router,
              public authGuard: AuthGuard,
              private machinesService: MachinesService) {
    this.machinesMap = new Map<string, Machine>();
  }

  @Input()
  set machineUuid(machineUuid: string) {
    if (this.machinesMap.has(machineUuid)) {
      this.machine = this.machinesMap.get(machineUuid);
      this.setLastAlarmDates(this.machine);
    } else {
      this.machinesService.getMachineMap(machineUuid).subscribe(
        response => {
          this.machine = response.machine;
          this.setLastAlarmDates(this.machine);
          this.machinesMap.set(machineUuid, this.machine);
        });
    }
  }

  private setLastAlarmDates(machine: Machine): void {
    this.lastEventDate = undefined;
    this.lastAlarmDate = undefined;

    if ((machine.telemetryData?.hasAlarms || machine.telemetryData?.hasEvents)
      && machine.telemetryData?.activeAlarms.length > 0) {

      machine.telemetryData.activeAlarms.forEach((alarm: AlarmTelemetryData) => {

        if (alarm.alarmType == AlarmType.ALARM && (this.lastAlarmDate == undefined
          || new Date(this.lastAlarmDate) < new Date(alarm.activationDate))) {
          this.lastAlarmDate = alarm.activationDate;

        } else if (alarm.alarmType == AlarmType.EVENT && (this.lastEventDate == undefined
          || new Date(this.lastEventDate) < new Date(alarm.activationDate))) {
          this.lastEventDate = alarm.activationDate;
        }
      });
    }
  }

}
